var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85602 11.4281C4.74521 11.2361 4.59767 11.0677 4.4218 10.9327C4.24593 10.7976 4.04519 10.6986 3.83104 10.6411C3.61688 10.5837 3.39351 10.5689 3.17367 10.5978C2.95383 10.6267 2.74182 10.6986 2.54977 10.8094C2.35771 10.9202 2.18935 11.0677 2.05432 11.2436C1.91928 11.4195 1.82021 11.6202 1.76275 11.8344C1.70529 12.0485 1.69058 12.2719 1.71945 12.4917C1.74832 12.7116 1.82021 12.9236 1.93102 13.1156L5.39976 19.125C6.30405 20.657 7.77656 21.7701 9.49714 22.2223C11.2177 22.6744 13.0472 22.429 14.5878 21.5395C16.1285 20.6499 17.2556 19.1882 17.7243 17.472C18.1929 15.7559 17.9651 13.9241 17.0904 12.375L15.4966 9.60938C15.2591 9.25117 14.8939 8.99709 14.4754 8.89898C14.057 8.80086 13.6169 8.86611 13.2449 9.08141C12.8729 9.2967 12.5971 9.64582 12.4737 10.0575C12.3504 10.4692 12.3887 10.9125 12.581 11.2969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0313 13.6406L6.46881 7.47188C6.35801 7.27982 6.21046 7.11147 6.03459 6.97643C5.85873 6.84139 5.65799 6.74232 5.44383 6.68486C5.22968 6.62741 5.0063 6.61269 4.78646 6.64156C4.56662 6.67043 4.35462 6.74232 4.16256 6.85313C3.9705 6.96393 3.80215 7.11148 3.66711 7.28734C3.53207 7.46321 3.433 7.66395 3.37554 7.8781C3.31809 8.09226 3.30337 8.31563 3.33225 8.53548C3.36112 8.75532 3.43301 8.96732 3.54381 9.15938L7.10631 15.3281",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0811 13.9031L10.1436 7.07813C9.91984 6.69025 9.55115 6.40715 9.11864 6.29111C8.68613 6.17507 8.22525 6.2356 7.83737 6.45938C7.44949 6.68315 7.16639 7.05185 7.05035 7.48436C6.93431 7.91686 6.99484 8.37775 7.21862 8.76563",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28112 6.34687L8.31549 4.66875C8.09172 4.28087 7.72302 3.99777 7.29051 3.88174C6.85801 3.7657 6.39712 3.82622 6.00924 4.05C5.62136 4.27378 5.33827 4.64247 5.22223 5.07498C5.10619 5.50748 5.16672 5.96837 5.39049 6.35625L5.61549 6.74062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 17.9531C18.7692 16.917 19.5243 15.5205 19.7648 13.9957C20.0053 12.471 19.7166 10.9098 18.9468 9.57188L17.3531 6.81563C17.2423 6.62357 17.0947 6.45522 16.9189 6.32018C16.743 6.18514 16.5423 6.08607 16.3281 6.02861C16.114 5.97116 15.8906 5.95644 15.6707 5.98531C15.4509 6.01418 15.2389 6.08607 15.0468 6.19688C14.8548 6.30768 14.6864 6.45523 14.5514 6.63109C14.4164 6.80696 14.3173 7.0077 14.2598 7.22185C14.2024 7.43601 14.1877 7.65938 14.2165 7.87923C14.2454 8.09907 14.3173 8.31107 14.4281 8.50313",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6439 8.87812L11.9908 4.28437C11.767 3.89649 11.3983 3.6134 10.9658 3.49736C10.5333 3.38132 10.0724 3.44185 9.68454 3.66562C9.29666 3.8894 9.01356 4.2581 8.89752 4.6906C8.78148 5.12311 8.84201 5.58399 9.06578 5.97187",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5748 1.05937L16.1904 2.50312",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4157 2.38125L18.5532 3.60937",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6188 4.58437L20.3906 5.44687",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplause);
export default __webpack_public_path__ + "static/media/applause.d12c3526b1f0d81036a08c39af61b8ac.svg";
export { ForwardRef as ReactComponent };